import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import PropTypes from 'prop-types';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SimpleList = props => {
    const { dataList, name, selectAccount} = props
    const classes = useStyles();
    return (
        <List className={classes.root}>
            {
                dataList.map( data => {
                    return  <ListItem key = {data.Codigo} button onClick={() => selectAccount(data)} >
                                <ListItemAvatar>
                                <Avatar>
                                    <AccountBalanceWalletIcon />
                                </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={`${name} - ${data.Codigo}`}
                                    secondary={data.TipoCuenta} />
                            </ListItem>
                })
            }
        </List>
    );
};

SimpleList.propTypes = {
    dataList: PropTypes.array.isRequired,
};

export default SimpleList;